import * as Yup from 'yup';

export const notes = Yup.string()
  .min(10, 'Your notes should be more than 10 symbols')
  .max(500, 'Your notes should be less than 500 symbols')
  .required("You can't block the user without any reason");
